module.exports = __webpack_public_path__ + "img/NoWeb@3x.0f218a82.png";